import { useEffect, useState } from "react";
import { usePatientAuthFlags } from "../../Hooks/usePatientAuthFlags";
import { isAgentModeFlagSet } from "./creAgentMode";

/**
 * Agent mode for the CRE patient page. Only active for CRE sessions opened by
 * the Windows agent; always false otherwise (R4V, normal CRE tabs).
 */
export function useCreAgentMode() {
  const { isCreAuth } = usePatientAuthFlags();
  return { agentMode: isCreAuth && isAgentModeFlagSet() };
}

/** Space the editor leaves for its header, toolbar and Template Instructions (px). */
export const AGENT_EDITOR_CHROME_PX = 300;
export const AGENT_EDITOR_MIN_PX = 160;

export function agentEditorHeight(windowHeight) {
  return Math.max(AGENT_EDITOR_MIN_PX, Math.round(windowHeight - AGENT_EDITOR_CHROME_PX));
}

/**
 * Agent Mode: report editor height that fits the agent window (compact or
 * expanded — the agent resizes its window, the editor follows).
 */
export function useAgentEditorHeight(enabled) {
  const read = () => (typeof window === "undefined" ? 0 : window.innerHeight);
  const [h, setH] = useState(read);
  useEffect(() => {
    if (!enabled || typeof window === "undefined") return undefined;
    const onResize = () => setH(window.innerHeight);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [enabled]);
  return agentEditorHeight(h);
}
